// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';

import './TaskContent.scss';

export const TaskContent = ({ data: task, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();
    const { title, case: caseData, _id: taskId } = task || {};
    const { action, details, context } = base;

    const detailsCreated = {
        description: details?.description,
    };

    return (
        <StreamCard
            icon={<ICONS.TaskIcon />}
            title={caseData?._id ? title : `${details.title}  (${local('stream.card.case.delete')})`}
            path={caseData?._id ? RouteBuilder.compute('cases.task', { caseId: caseData?._id, taskId }) : null}
            base={base}
            parent={context}
            information="task"
        >
            {action === 'create' &&
                Object.entries(detailsCreated).map(([key, value]) => (
                    <PropRender key={taskId + key} prop={key} value={value} type="task" />
                ))}
            {action === 'update' &&
                Object.entries(details).map(([key, value]) => (
                    <PropRender key={taskId + key} prop={key} value={value} type="task" />
                ))}
        </StreamCard>
    );
};
